import axios from 'axios'
import moment from 'moment'
import emailApi from '@/api/email'

export default {
  state: {
    task: null,
    tasks: [],
  },
  actions: {
    async fetchTasks({ commit, state }, payload) {
      commit('SET_TASKS', [])

      let url = new URL(`https://europe-west3-freelance-dev-df97d.cloudfunctions.net/task`)

      Object.keys(payload.params).forEach(key => {
        url.searchParams.set(key, payload.params[key])
      })

      const { data } = await axios.get(url, {
        headers: {
          Authorization: payload.userId,
        },
      })
      commit('SET_TASKS', data.tasks)
    },
    async fetchTaskById({ commit, state, rootState }, { taskId }) {
      commit('SET_TASK', null)

      let url = new URL(`https://europe-west3-freelance-dev-df97d.cloudfunctions.net/task`)
      url.searchParams.set('endpoint', 'getbyid')
      url.searchParams.set('id', taskId)

      const { data } = await axios.get(url, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })

      commit('SET_TASK', data.task)
    },
    async createTask({ commit, state, rootState, dispatch }, { task }) {
      let url = 'https://europe-west3-freelance-dev-df97d.cloudfunctions.net/task?endpoint=create'
      const userId = rootState.user.user.data.uid
      task.createdBy = userId

      const { data } = await axios.post(url, task, {
        headers: {
          Authorization: userId,
        },
      })

      if (task.claimedBy) {
        const user = await dispatch('fetchUserById', { userId: task.claimedBy }, { root: true })

        const emailData = {
          subject: 'New task assigned',
          recipients: [user.email],
          //FIXME: See if there is specific text that needs to be written in the email
          body: `Dear ${user.name}, You have been assigned a new task. You can find it on https://freelance.trafficlab.dk/#/task/${data.task.id}.`,
        }
        emailApi.sendEmail(emailData)
      }
      return data.task
    },
    async claimTaskById({ commit, state, rootState, dispatch }, { taskId }) {
      commit('SET_TASK', null)

      let url = new URL(`https://europe-west3-freelance-dev-df97d.cloudfunctions.net/task`)
      url.searchParams.set('endpoint', 'claimbyid')
      url.searchParams.set('id', taskId)

      const { data } = await axios.get(url, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })
      commit('SET_TASK', data.task)

      await dispatch('setTaskDeadline', { task: data.task })
    },
    async saveTask({ commit, state, rootState }, { task }) {
      const url = 'https://europe-west3-freelance-dev-df97d.cloudfunctions.net/task?endpoint=update'

      const { data } = await axios.patch(url, task, {
        headers: {
          Authorization: rootState.user.user.data.uid,
        },
      })

      commit('SET_TASK', data.task)
    },
    async setTaskDeadline({ commit, state, rootState, dispatch }, { task }) {
      if (task.deadlineAt === '0001-01-01T00:00:00.000Z' || task.deadlineAt === '0001-01-01T00:00:00Z') {
        task.deadlineAt = moment()
          .add(5, 'days')
          .toISOString()

        await dispatch('saveTask', { task })
      }
    },
  },
  mutations: {
    SET_TASKS(state, data) {
      state.tasks = data
    },
    SET_TASK(state, data) {
      state.task = data
    },
  },
  getters: {
    task(state) {
      return state.task
    },
    tasks(state) {
      return state.tasks
    },
  },
}
